var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99975 13.3334L11.6664 13.3334C12.771 13.3334 13.6664 12.4379 13.6664 11.3334L13.6664 4.66671C13.6664 3.56214 12.771 2.66671 11.6664 2.66671L4.2146 2.66671C3.11003 2.66671 2.2146 3.56214 2.2146 4.66671L2.2146 7.72172",
    stroke: "#717B8E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.70567 6.59127L9.34327 6.59127M9.34327 6.59127L9.34327 10.2289M9.34327 6.59127L2.7904 12.6545",
    stroke: "#717B8E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessesIcon);
export default __webpack_public_path__ + "static/media/AccessesIcon.5c4654e9fd0acc42e430ae4cff35dc9b.svg";
export { ForwardRef as ReactComponent };